<template>

    <section class="products pb-0">
        <div class="container">
            <div class="row" style="position: relative">

                <div class="col-md-12 col-lg-3" >
                    <transition name="fade">
                        <component :is="filterComponent" :class="{ 'product-sidebar--open': toggleFilter }" v-show="stateFilters"></component>
                    </transition>
                    <transition name="reverse-fade">
                        <div v-show="!stateFilters">
                            <filter-skeleton />
                        </div>
                    </transition>
                </div>


                <div class="col-md-12 col-lg-9">
                    <div class="row">
                        <div class="col-md-12">

                            <div class="filter-bar--track">
                                <div class="filter-bar--wrapper">
                                    <div class="filter-bar d-flex">
                                        <div class="filter__option filter__option-blocks filter--text d-flex">
                                            <a class="filter__option-block" href="#"
                                               @click.prevent="changeTab({type: 'animals', filter: 'help', needSum: true}, 'activePetsFilters')"
                                               :class="{activeCatalogType: type === 'animals' && needSum }">{{$store.getters.t('catalog_products_need_help')}}</a>
                                            <a class="filter__option-block" href="#"
                                               @click.prevent="changeTab({type: 'animals', filter: 'friend', needSum: false}, 'activePetsFilters')"
                                               :class="{activeCatalogType: type === 'animals' && !needSum }">{{$store.getters.t('catalog_products_need_friend')}}</a>
                                            <a class="filter__option-block" href="#"
                                               @click.prevent="changeTab({type: 'projects', filter: 'projects', needSum: false}, 'activeProjectsFilters')"
                                               :class="{activeCatalogType: type === 'projects'}">{{$store.getters.t('catalog_products_projects')}}</a>
                                        </div>
                                        <div v-if="stateCatalogList.arr.length">
                                            <div class="filter__option filter--select filter--select-long">
                                                <a v-if="type === 'animals'"
                                                   :href="`/pets/${catalogListRandomTarget}`"
                                                   class="btn btn-md"
                                                   target="_blank">
                                                    {{$store.getters.t('catalog_products_choose_for_me')}}
                                                    </a>
                                                <a v-else
                                                   :href="`/projects/${catalogListRandomTarget}`"
                                                   class="btn btn-md"
                                                   target="_blank">
                                                    {{$store.getters.t('catalog_products_choose_for_me')}}
                                                    </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- end /.dashboard_menu -->
                        </div>
                        <!-- end /.col-md-12 -->
                    </div>

                    <div class="row" v-if="!stateCatalogList.arr.length && !fetched">
                        <div class="col-12 catalog--empty">
                            {{$store.getters.t('catalog_products_empty')}}
                        </div>
                    </div>

                    <transition name="fade">

                        <div class="row" v-show="stateCatalogList.arr.length && !fetched">
                            <div class="col-12 col-sm-6 col-md-6 col-xl-12" v-for="item in stateCatalogList.arr">
                                <component :is="catalogProduct" :item="item"></component>
                            </div>
                        </div>

                    </transition>

                    <transition name="reverse-fade">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row" v-show="!stateCatalogList.arr.length && fetched">
                                    <div class="col-12 col-sm-6 col-md-6 col-xl-12" v-for="item in 6">
                                        <skeleton />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>


                </div>
            </div>

            <div class="row" v-if="stateCatalogList.meta && stateCatalogList.meta.last_page > 1">
                <div class="col-md-12">
                    <div class="pagination-area pull-right">
                        <nav class="navigation pagination" role="navigation">
                            <div class="nav-links">
                                <paginate
                                    v-model="page"
                                    :page-count="stateCatalogList.meta.last_page"
                                    :click-handler="paginateClickCallback"
                                    :prev-text="''"
                                    :next-text="''"
                                    :container-class="'className'"
                                    :page-class="'page-numbers'"
                                    :page-link-class="''"
                                    :active-class="'current'"
                                    :prev-class="'prev page-numbers'"
                                    :prev-link-class="'lnr lnr-arrow-left'"
                                    :next-class="'next page-numbers'"
                                    :next-link-class="'lnr lnr-arrow-right'"
                                >
                                </paginate>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div style="background-color: #f5f7fb; margin-top: 50px!important; padding: 40px 0">
            <random-pets-or-projects-component :type="type"></random-pets-or-projects-component>
        </div>

        <!-- end /.container -->
    </section>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {paginationScrollTo} from '../helpers/helpers';

import Pet from './CatalogPet';
import Project from './CatalogProject';
import Skeleton from './CatalogSkeleton';

import FilterNeedHelp from "./FilterNeedHelp";
import FilterNeedFriend from "./FilterNeedFriend";
import FilterProjects from "./FilterProjects";
import FilterSkeleton from "./FilterSkeleton";
import catalog from "../../store/catalog";

export default {
    name: "CatalogProducts",
    components: { Pet, Project, FilterNeedHelp, FilterNeedFriend, FilterSkeleton, FilterProjects, Skeleton },
    data(){
      return{
          placeholder: Skeleton,
          placeholderFilter: FilterSkeleton,
      }
    },
    computed: {

        ...mapGetters({ sliceState: 'sliceByKey' }),

        filterComponent()   {

            let component = this.placeholderFilter;

            switch (this.filter) {
                case 'help':
                    component = FilterNeedHelp;
                    break;
                case 'friend':
                    component = FilterNeedFriend;
                    break;
                case 'projects':
                    component = FilterProjects;
                    break;
                default:
                    component = this.placeholderFilter;
            }

            return component;

        },

        catalogProduct()   {
            let component = this.placeholder;

            switch (this.type) {
                case 'animals':
                    component = Pet;
                    break;
                case 'projects':
                    component = Project;
                    break;
                default:
                    component = this.placeholder;
            }

            return component;
        },

        stateCatalogList() { return this.sliceState( 'list' ) },

        catalogListRandomTarget() {

            if ( ! this.stateCatalogList.arr.length ) return;

            const _idx = Math.round(Math.random() * (this.stateCatalogList.arr.length - 1));
            return  this.stateCatalogList.arr[_idx]['id'];

        },

        stateFilters()     { return this.sliceState( this.type  ===  'animals'  ?  'filtersPets'  : 'filtersProjects' ) },

        layoutInitial()    { return this.sliceState( 'layoutInitial' ) },

        fetched()          { return this.sliceState( 'fetched' ) },

        type()             { return this.layoutInitial.type },

        needSum()          { return this.layoutInitial.needSum },

        filter()            { return this.layoutInitial.filter },

        toggleFilter()     { return this.sliceState( 'toggleFilter' ) },

        computedActiveFilters() { return this.sliceState( this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' ) },

        page: {
            get(){ return parseInt(this.computedActiveFilters.page) },
            set( val ){
                this.setState( {
                            key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters',
                            data: { ...this.computedActiveFilters, page: val }
                        } )
            }
        },

    },

    methods: {

        ...mapMutations({ setState: 'setterByKey', resetSliceState: 'resetByKey' }),

        ...mapActions({ dataForCatalog: 'getInitDataForCatalog', list: 'getList' }),

        changeTab( data, target ){

            const promise = new Promise( (res, rej) =>  {
              this.resetSliceState({ key: 'list' });
              this.setState({key: 'layoutInitial', data: data});
              this.setState({key: 'fetched', data: true});
              this.resetSliceState({ key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' });
              this.resetSliceState({ key: 'search' });
              res();
            }).then(() => { this.list( { key: target }) })
              .catch( ( _e ) => console.log( _e ) );

        },

        paginateClickCallback(pageNum) {
            paginationScrollTo('.products')
        },
    }

}
</script>

<style lang="scss" scoped>



.reverse-fade-leave-active {
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
    transition: opacity .2s
}

.reverse-fade-leave-to {
    transition: opacity .2s;
    opacity: 0
}

.fade-enter-active{
    transition: opacity .2s
}

.fade-enter{
    transition: opacity .2s;
    opacity: 0
}

.filter-bar {
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 0;
    min-width: 700px;
    overflow-x: visible;
    white-space: nowrap;

    &--track {
        overflow: hidden;
        border-radius: 5px;
        margin-bottom: 15px;

    }

    &--wrapper {
        overflow-x: auto;
    }

    .filter--text a + a {
        margin-left: 15px;
    }

    .filter__option {
        padding: 0;

        &-block {
            display: inline-block;
            padding: 20px 0 20px 15px;
            border: 3px solid transparent;
            border-left: none;

            &.activeCatalogType {

                border-bottom-color: #2E76E4;

            }

        }
    }

    .filter--select {
        padding: 0 15px;
        width: auto;
        flex-shrink: 0;
        margin: 0;

        .btn {
            display: block;
            border-radius: 45px;
        }

    }
}

.card-subtitle {
    margin: 10px 0;
    color: #0674ec;
}

.products {
    padding-top: 25px;
}

.products .swiper-container {
    width: 100%;
}


.product_title h4 {
    position: relative;
}


.v-name {
    display: inline-block;
    margin-left: 5px;
}

.already-have-money {
    color: #a3a3a3;
    font-size: 0.8rem;
}

.activeCatalogType {
    color: #0674ec !important;
}

.activeLink {
    color: #0674ec !important;
}


.product .product__thumbnail:before {
    display: none !important;
}

.city-filter {
    font-size: 0.7rem;
}


</style>
